import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { useDispatch } from "react-redux";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import {
  GetOffers,
  getOfferActions,
} from "src/offers/actions/OfferActionCreators";
import type Offer from "src/offers/objects/Offer";
import type {
  OfferAction,
  OfferActionType,
} from "src/offers/objects/OfferAction";

export const useOffers = <T = Offer[]>(
  merchantUuid: string | undefined,
  options?: UseQueryOptions<
    Offer[],
    unknown,
    T,
    ["offers", string | undefined]
  >,
) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  return useQuery(
    ["offers", merchantUuid],
    async () => {
      return await dispatch(GetOffers(merchantUuid));
    },
    options,
  );
};

export const useOfferActions = (
  countryCode: string,
  options?: UseQueryOptions<
    Map<OfferActionType, OfferAction>,
    unknown,
    Map<OfferActionType, OfferAction>,
    ["offerActions", string]
  >,
) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  return useQuery(
    ["offerActions", countryCode],
    async () => {
      const offerActions = await dispatch(getOfferActions(countryCode));
      return new Map(
        offerActions.map((offerAction) => [
          offerAction.action as OfferActionType,
          offerAction,
        ]),
      );
    },
    { staleTime: 60000, ...options },
  );
};
